import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { PATHS } from './routes/paths';
import RequireAuth from './routes/RequireAuth';
import RequireAdmin from './routes/RequireAdmin';
import ConfirmModal from './components/common/ConfirmModal';

import MainPage from './pages/Main/MainPage';
import LoginPage from './pages/Auth/LoginPage';
import RegisterPage from './pages/Auth/RegisterPage';
import MyPage from './pages/MyPage/MyPage';

import UserManagement from './pages/Admin/UserManagement';
import AdminStats from './pages/Admin/AdminStats';

import NewsList from './pages/News/NewsList';
import NewsDetail from './pages/News/NewsDetail';
import NewsWrite from './pages/News/NewsWrite';

import ServiceLinkManagement from './pages/Admin/ServiceLinkManagement';

import LinkGroupPage from './pages/Links/LinkGroupPage';
import LinkGroupManagement from './pages/Links/LinkGroupManagement';
import LinkGroupItemManagement from './pages/Links/LinkGroupItemManagement';

import ShopList from './pages/Shops/ShopList';
import ShopDetail from './pages/Shops/ShopDetail';
import ShopRegister from './pages/Shops/ShopRegister';
import ShopManagement from './pages/Shops/ShopManagement';

import EtravelPickdropPage from './pages/Travel/EtravelPickdropPage';

import InboxList from './pages/Inbox/InboxList';
import ChatRoom from './pages/Inbox/ChatRoom';

function SessionExpiredWatcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    const handler = () => {
      setOpen(true);
    };
    window.addEventListener('auth:expired', handler);
    return () => window.removeEventListener('auth:expired', handler);
  }, []);

  const handleConfirm = () => {
    setOpen(false);
    if (typeof window !== 'undefined') {
      window.__authExpiredNotified = false;
    }
    navigate(PATHS.login, {
      replace: true,
      state: { from: `${location.pathname}${location.search}` },
    });
  };

  return (
    <ConfirmModal
      open={open}
      message="로그인을 새로 해주세요."
      confirmText="확인"
      onConfirm={handleConfirm}
    />
  );
}

function App() {
  return (
    <BrowserRouter>
      <SessionExpiredWatcher />
      <Routes>
        <Route path={PATHS.root} element={<MainPage />} />

        <Route path={PATHS.login} element={<LoginPage />} />
        <Route path={PATHS.register} element={<RegisterPage />} />
        <Route
          path={PATHS.myPage}
          element={(
            <RequireAuth>
              <MyPage />
            </RequireAuth>
          )}
        />

        <Route
          path={PATHS.adminUsers}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <UserManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.adminStats}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <AdminStats />
              </RequireAdmin>
            </RequireAuth>
          )}
        />
        <Route path={PATHS.newsList} element={<NewsList />} />
        <Route path={PATHS.newsDetail} element={<NewsDetail />} />
        <Route
          path={PATHS.newsWrite}
          element={(
            <RequireAuth>
              <NewsWrite />
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.newsEdit}
          element={(
            <RequireAuth>
              <NewsWrite />
            </RequireAuth>
          )}
        />

        <Route
          path={PATHS.adminServiceLinks}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <ServiceLinkManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />

        <Route path={PATHS.links} element={<LinkGroupPage />} />
        <Route
          path={PATHS.adminLinkGroups}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <LinkGroupManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.adminLinkGroupItems}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <LinkGroupItemManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.adminLinkGroupItemsEdit}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <LinkGroupItemManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />

        <Route path={PATHS.shops} element={<ShopList />} />
        <Route path={PATHS.shopDetail} element={<ShopDetail />} />
        <Route
          path={PATHS.shopRegister}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <ShopRegister />
              </RequireAdmin>
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.adminShops}
          element={(
            <RequireAuth>
              <RequireAdmin>
                <ShopManagement />
              </RequireAdmin>
            </RequireAuth>
          )}
        />

        <Route path={PATHS.etravelPickdrop} element={<EtravelPickdropPage />} />

        <Route
          path={PATHS.inbox}
          element={(
            <RequireAuth>
              <InboxList />
            </RequireAuth>
          )}
        />
        <Route
          path={PATHS.inboxRoom}
          element={(
            <RequireAuth>
              <ChatRoom />
            </RequireAuth>
          )}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

